<div id="insertcoin" class="d-flex flex-column justify-content-center align-items-center h-100">
  <div class="d-flex flex-row  justify-content-center align-items-center spin-disc spinning">
    <div class="progress-line">
      <svg id="svg" width="208" height="208" viewPort="0 0 104 104" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <circle r="100" cx="104" cy="104" fill="transparent"></circle>
        <circle id="bar" r="100" cx="104" cy="104" fill="transparent">
        </circle>
      </svg>
    </div>
    <div class="d-flex flex-row  justify-content-center align-items-center logo">
      <img src="{{ assetsUrl }}/assets/images/intro/logo-popcorn.svg" class="logo_popcorn">
    </div>
    <div class="d-flex flex-row  justify-content-center align-items-center">
      <button type="button" class="round-button" (click)="insertCoin()" (mouseover)="rollOver()" (mouseout)="rollOut()">
        Jouer
      </button>
    </div>
  </div>
</div>

<div #prehome id="prehome" class="flex-column justify-content-center align-items-center h-100">
  <div class="d-flex flex-row align-items-end">
    <div class="bloc-logo">
      <img class="redbull" src="{{ assetsUrl }}/assets/images/intro/logo-flashback.png" data-pin-nopin="true" />
    </div>
  </div>
  <div class="d-flex flex-row press-any-key">{{ action }} pour commencer</div>
  <!-- <div class="flex-row best-with">
    <div>
      <svg class="fullscreen" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="49px"
        height="38px">
        <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="2px" stroke-linecap="butt"
          stroke-linejoin="miter" fill="none"
          d="M45.650,35.798 L41.600,35.798 L41.600,34.448 L45.650,34.448 L45.650,30.398 L47.000,30.398 L47.000,34.448 L47.000,35.798 L45.650,35.798 ZM44.300,2.725 L40.250,2.725 L40.250,1.375 L44.300,1.375 L45.650,1.375 L45.650,2.725 L45.650,6.775 L44.300,6.775 L44.300,2.725 ZM7.184,6.768 L39.583,6.768 L39.583,30.388 L7.184,30.388 L7.184,6.768 ZM1.100,35.798 L1.100,34.448 L1.100,30.398 L2.450,30.398 L2.450,34.448 L6.500,34.448 L6.500,35.798 L2.450,35.798 L1.100,35.798 ZM2.450,6.775 L1.100,6.775 L1.100,2.725 L1.100,1.375 L2.450,1.375 L6.500,1.375 L6.500,2.725 L2.450,2.725 L2.450,6.775 Z" />
      </svg>
    </div>
    <div class="plus">+</div>
    <div>
      <svg class="headphones" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42px"
        height="36px">
        <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
          d="M41.069,35.110 L36.994,35.110 C36.696,35.110 36.454,34.870 36.454,34.573 L36.454,21.157 C36.454,20.864 36.691,20.625 36.986,20.620 L41.077,20.628 C41.369,20.633 41.604,20.867 41.609,21.157 L41.609,34.582 C41.604,34.875 41.364,35.110 41.069,35.110 ZM21.906,1.880 C17.195,1.692 12.615,3.450 9.255,6.735 C5.929,9.945 3.991,14.313 3.851,18.916 L2.135,18.916 C2.140,14.083 4.035,9.441 7.419,5.968 C7.651,5.725 7.890,5.487 8.136,5.256 C15.630,-1.793 27.460,-1.474 34.558,5.968 C37.955,9.436 39.862,14.079 39.876,18.916 L38.161,18.916 C37.946,9.895 30.818,2.340 21.906,1.880 ZM5.583,21.157 L5.583,34.582 C5.579,34.875 5.338,35.110 5.043,35.110 L0.969,35.110 C0.670,35.110 0.428,34.870 0.428,34.573 L0.428,21.157 C0.428,20.864 0.665,20.625 0.960,20.620 L5.052,20.628 C5.343,20.633 5.579,20.867 5.583,21.157 ZM8.997,34.250 L7.282,34.250 L7.282,22.324 L8.997,22.324 L8.997,34.250 ZM34.730,34.250 L33.014,34.250 L33.014,22.324 L34.730,22.324 L34.730,34.250 Z" />
      </svg>
    </div>
  </div> -->
  <!-- <div class="flex-row best-with">
    <div class="reco">
      pour une meilleure<br />
      expérience
    </div>
  </div> -->
</div>
